export const INIT_EDIT_QUOTE = 'quote/INIT_EDIT_QUOTE';

export const EXPORT_TO_EXCEL_ERROR = 'quotes/EXPORT_TO_EXCEL_ERROR';
export const EXPORT_TO_EXCEL_REQUEST = 'quotes/EXPORT_TO_EXCEL_REQUEST';
export const EXPORT_TO_EXCEL_SUCCESS = 'quotes/EXPORT_TO_EXCEL_SUCCESS';

export const ADD_EXCEL_EXPORT_TASKS = 'quotes/ADD_EXCEL_EXPORT_TASKS';
export const REMOVE_EXCEL_EXPORT_TASKS = 'quotes/REMOVE_EXCEL_EXPORT_TASKS';

export const FETCH_EMAIL_TEMPLATES = 'quote/FETCH_EMAIL_TEMPLATES';
export const FETCH_EMAIL_TEMPLATES_SUCCESS =
  'quote/FETCH_EMAIL_TEMPLATES_SUCCESS';
export const FETCH_EMAIL_TEMPLATES_ERROR = 'quote/FETCH_EMAIL_TEMPLATES_ERROR';

export const UPLOAD_REQUEST = 'quote/UPLOAD_REQUEST';
export const UPLOAD_BOM_GENERATION_REQUEST =
  'quote/UPLOAD_BOM_GENERATION_REQUEST';
export const UPLOAD_SUCCESS = 'quote/UPLOAD_SUCCESS';
export const UPLOAD_ERROR = 'quote/UPLOAD_ERROR';
export const QUOTE_RECEIVE = 'quote/QUOTE_RECEIVE';
export const QUOTE_CLEAR = 'quote/QUOTE_CLEAR';
export const QUOTE_REFRESH_REQUEST = 'quote/QUOTE_REFRESH_REQUEST';
export const QUOTE_REFRESH_SUCCESS = 'quote/QUOTE_REFRESH_SUCCESS';
export const QUOTE_REFRESH_ERROR = 'quote/QUOTE_REFRESH_ERROR';
export const QUOTE_FINALIZE_FLOW = 'quote/QUOTE_FINALIZE_FLOW';
export const QUOTE_FINALIZE_REQUEST = 'quote/QUOTE_FINALIZE_REQUEST';
export const QUOTE_FINALIZE_SUCCESS = 'quote/QUOTE_FINALIZE_SUCCESS';
export const QUOTE_FINALIZE_ERROR = 'quote/QUOTE_FINALIZE_ERROR';
export const CLOSE_FINALIZE_MODAL = 'quote/CLOSE_FINALIZE_MODAL';
export const QUOTE_SEND_REQUEST = 'quote/QUOTE_SEND_REQUEST';
export const QUOTE_SEND_SUCCESS = 'quote/QUOTE_SEND_SUCCESS';
export const QUOTE_SEND_ERROR = 'quote/QUOTE_SEND_ERROR';
export const QUOTE_METADATA_UPDATE_REQUEST =
  'quote/QUOTE_METADATA_UPDATE_REQUEST';
export const QUOTE_METADATA_UPDATE_SUCCESS =
  'quote/QUOTE_METADATA_UPDATE_SUCCESS';
export const QUOTE_METADATA_UPDATE_ERROR = 'quote/QUOTE_METADATA_UPDATE_ERROR';
export const CONVERT_QUOTE_FILES_TO_LINE_ITEMS_REQUEST =
  'quotes/CONVERT_QUOTE_FILES_TO_LINE_ITEMS_REQUEST';
export const CONVERT_QUOTE_FILES_TO_LINE_ITEMS_FINISH =
  'quotes/CONVERT_QUOTE_FILES_TO_LINE_ITEMS_FINISH';
export const RECEIVE_QUANTITIES = 'quote/RECEIVE_QUANTITIES';
export const QUANTITY_UPDATE_REQUEST = 'quote/QUANTITY_UPDATE_REQUEST';
export const QUANTITY_UPDATE_SUCCESS = 'quote/QUANTITY_UPDATE_SUCCESS';
export const QUANTITY_UPDATE_COMMIT = 'quote/QUANTITY_UPDATE_COMMIT';
export const QUANTITY_UPDATE_ERROR = 'quote/QUANTITY_UPDATE_ERROR';
export const EXPEDITES_UPDATE_REQUEST = 'quote/EXPEDITES_UPDATE_REQUEST';
export const EXPEDITES_UPDATE_SUCCESS = 'quote/EXPEDITES_UPDATE_SUCCESS';
export const EXPEDITES_UPDATE_ERROR = 'quote/EXPEDITES_UPDATE_ERROR';
export const FEATURES_UPDATE_REQUEST = 'quote/FEATURES_UPDATE_REQUEST';
export const FEATURES_UPDATE_SUCCESS = 'quote/FEATURES_UPDATE_SUCCESS';
export const FEATURES_UPDATE_ERROR = 'quote/FEATURES_UPDATE_ERROR';
export const OVERRIDES_UPDATE_REQUEST = 'quote/OVERRIDES_UPDATE_REQUEST';
export const OVERRIDES_UPDATE_SUCCESS = 'quote/OVERRIDES_UPDATE_SUCCESS';
export const OVERRIDES_UPDATE_COMMIT = 'quote/OVERRIDES_UPDATE_COMMIT';
export const OVERRIDES_UPDATE_ERROR = 'quote/OVERRIDES_UPDATE_ERROR';
export const PRIVATE_NOTES_UPDATE_REQUEST =
  'quote/PRIVATE_NOTES_UPDATE_REQUEST';
export const PRIVATE_NOTES_UPDATE_SUCCESS =
  'quote/PRIVATE_NOTES_UPDATE_SUCCESS';
export const PRIVATE_NOTES_UPDATE_ERROR = 'quote/PRIVATE_NOTES_UPDATE_ERROR';
export const PUBLIC_NOTES_UPDATE_REQUEST = 'quote/PUBLIC_NOTES_UPDATE_REQUEST';
export const PUBLIC_NOTES_UPDATE_SUCCESS = 'quote/PUBLIC_NOTES_UPDATE_SUCCESS';
export const PUBLIC_NOTES_UPDATE_ERROR = 'quote/PUBLIC_NOTE_UPDATE_ERROR';

export const ESTIMATOR_SELECT_ERROR = 'quote/ESTIMATOR_SELECT_ERROR';
export const ESTIMATOR_SELECT_REQUEST = 'quote/ESTIMATOR_SELECT_REQUEST';
export const ESTIMATOR_SELECT_SUCCESS = 'quote/ESTIMATOR_SELECT_SUCCESS';

export const SALESPERSON_SELECT_ERROR = 'quote/SALESPERSON_SELECT_ERROR';
export const SALESPERSON_SELECT_REQUEST = 'quote/SALESPERSON_SELECT_REQUEST';
export const SALESPERSON_SELECT_SUCCESS = 'quote/SALESPERSON_SELECT_SUCCESS';

export const SUPPLIER_FACILITY_SELECT_ERROR =
  'quote/SUPPLIER_FACILITY_SELECT_ERROR';
export const SUPPLIER_FACILITY_SELECT_REQUEST =
  'quote/SUPPLIER_FACILITY_SELECT_REQUEST';
export const SUPPLIER_FACILITY_SELECT_SUCCESS =
  'quote/SUPPLIER_FACILITY_SELECT_SUCCESS';

export const CONTACT_SELECT_ERROR = 'quote/CONTACT_SELECT_ERROR';
export const CONTACT_SELECT_REQUEST = 'quote/CONTACT_SELECT_REQUEST';
export const CONTACT_SELECT_SUCCESS = 'quote/CONTACT_SELECT_SUCCESS';

export const CHANGE_TAX_REQUEST = 'quote/CHANGE_TAX_REQUEST';
export const CHANGE_TAX_SUCCESS = 'quote/CHANGE_TAX_SUCCESS';
export const CHANGE_TAX_ERROR = 'quote/CHANGE_TAX_ERROR';

export const SAVE_QUOTE_SETTINGS_BY_ID = 'quote/SAVE_QUOTE_SETTINGS_BY_ID';

export const QUOTE_CANCEL_REQUEST = 'quote/QUOTE_CANCEL_REQUEST';
export const QUOTE_CANCEL_SUCCESS = 'quote/QUOTE_CANCEL_SUCCESS';
export const QUOTE_CANCEL_ERROR = 'quote/QUOTE_CANCEL_ERROR';
export const OPEN_CANCEL_QUOTE_CONFIRMATION_MODAL =
  'quote/OPEN_CANCEL_QUOTE_CONFIRMATION_MODAL';
export const CONFIRM_CANCEL_QUOTE = 'quote/CONFIRM_CANCEL_QUOTE';
export const CLOSE_CANCEL_QUOTE_CONFIRMATION_MODAL =
  'quote/CLOSE_CANCEL_QUOTE_CONFIRMATION_MODAL';

export const QUOTE_MARK_SENT_REQUEST = 'quote/QUOTE_MARK_SENT_REQUEST';
export const QUOTE_MARK_SENT_SUCCESS = 'quote/QUOTE_MARK_SENT_SUCCESS';
export const QUOTE_MARK_SENT_ERROR = 'quote/QUOTE_MARK_SENT_ERROR';

export const QUOTE_MARK_LOST_REQUEST = 'quote/QUOTE_MARK_LOST_REQUEST';
export const QUOTE_MARK_LOST_SUCCESS = 'quote/QUOTE_MARK_LOST_SUCCESS';
export const QUOTE_MARK_LOST_ERROR = 'quote/QUOTE_MARK_LOST_ERROR';

export const QUOTE_DELETE_FLOW = 'quote/QUOTE_DELETE_FLOW';
export const QUOTE_DELETE_REQUEST = 'quote/QUOTE_DELETE_REQUEST';
export const QUOTE_DELETE_SUCCESS = 'quote/QUOTE_DELETE_SUCCESS';
export const QUOTE_DELETE_ERROR = 'quote/QUOTE_DELETE_ERROR';

export const QUOTE_CREATE_REVISION_REQUEST =
  'quote/QUOTE_CREATE_REVISION_REQUEST';
export const QUOTE_CREATE_REVISION_SUCCESS =
  'quote/QUOTE_CREATE_REVISION_SUCCESS';
export const QUOTE_CREATE_REVISION_ERROR = 'quote/QUOTE_CREATE_REVISION_ERROR';

export const QUOTE_COPY_REQUEST = 'quote/QUOTE_COPY_REQUEST';
export const QUOTE_COPY_SUCCESS = 'quote/QUOTE_COPY_SUCCESS';
export const QUOTE_COPY_ERROR = 'quote/QUOTE_COPY_ERROR';

export const QUOTE_CREATE_CSV_REQUEST = 'quote/QUOTE_CREATE_CSV_REQUEST';
export const QUOTE_CREATE_CSV_SUCCESS = 'quote/QUOTE_CREATE_CSV_SUCCESS';
export const QUOTE_CREATE_CSV_ERROR = 'quote/QUOTE_CREATE_CSV_ERROR';

export const CUSTOMER_FACING_NOTES_UPDATE =
  'quote/CUSTOMER_FACING_NOTES_UPDATE';
export const CUSTOMER_FACING_NOTES_UPDATE_SUCCESS =
  'quote/CUSTOMER_FACING_NOTES_UPDATE_SUCCESS';
export const CUSTOMER_FACING_NOTES_UPDATE_ERROR =
  'quote/CUSTOMER_FACING_NOTES_UPDATE_ERROR';

export const QUOTES_PRIVATE_NOTES_UPDATE = 'quotes/QUOTES_PRIVATE_NOTES_UPDATE';
export const QUOTES_PRIVATE_NOTES_UPDATE_SUCCESS =
  'quotes/QUOTES_PRIVATE_NOTES_UPDATE_SUCCESS';
export const QUOTES_PRIVATE_NOTES_UPDATE_ERROR =
  'quotes/QUOTES_PRIVATE_NOTES_UPDATE_ERROR';

// TODO: DO WE STILL USE THIS?
export const APPLY_EXPEDITE_OPTIONS_ROW_TO_ALL =
  'quotes/APPLY_EXPEDITE_OPTIONS_ROW_TO_ALL';
export const COPY_EXPEDITE_OPTIONS_ROW = 'quotes/COPY_EXPEDITE_OPTIONS_ROW';
export const COPY_ALL_EXPEDITE_OPTIONS = 'quotes/COPY_ALL_EXPEDITE_OPTIONS';
export const PASTE_EXPEDITE_OPTIONS_ROW = 'quotes/PASTE_EXPEDITE_OPTIONS_ROW';
export const PASTE_ALL_EXPEDITE_OPTIONS = 'quotes/PASTE_ALL_EXPEDITE_OPTIONS';
export const CLEAR_EXPEDITE_OPTIONS_ROW = 'quotes/CLEAR_EXPEDITE_OPTIONS_ROW';
export const CLEAR_ALL_EXPEDITE_OPTIONS = 'quotes/CLEAR_ALL_EXPEDITE_OPTIONS';

export const FINISH_UPDATING_EXPEDITE_OPTIONS =
  'quotes/FINISH_UPDATING_EXPEDITE_OPTIONS';

export const APPLY_QUOTE_EXPEDITE_OPTIONS_REQUEST =
  'quotes/APPLY_QUOTE_EXPEDITE_OPTIONS_REQUEST';
export const APPLY_QUOTE_EXPEDITE_OPTIONS_SUCCESS =
  'quotes/APPLY_QUOTE_EXPEDITE_OPTIONS_SUCCESS';
export const APPLY_QUOTE_EXPEDITE_OPTIONS_ERROR =
  'quotes/APPLY_QUOTE_EXPEDITE_OPTIONS_ERROR';

export const CLEAR_QUOTE_EXPEDITE_OPTIONS_REQUEST =
  'quotes/CLEAR_QUOTE_EXPEDITE_OPTIONS_REQUEST';
export const CLEAR_QUOTE_EXPEDITE_OPTIONS_SUCCESS =
  'quotes/CLEAR_QUOTE_EXPEDITE_OPTIONS_SUCCESS';
export const CLEAR_QUOTE_EXPEDITE_OPTIONS_ERROR =
  'quotes/CLEAR_QUOTE_EXPEDITE_OPTIONS_ERROR';

export const CHANGE_EXPIRED_DATE = 'quotes/CHANGE_EXPIRED_DATE';

export const CHANGE_DUE_DATE_REQUEST = 'quotes/CHANGE_DUE_DATE_REQUEST';
export const CHANGE_DUE_DATE_ERROR = 'quotes/CHANGE_DUE_DATE_ERROR';

export const CHANGE_QUOTE_PRIORITY_REQUEST =
  'quotes/CHANGE_QUOTE_PRIORITY_REQUEST';
export const CHANGE_QUOTE_PRIORITY_ERROR = 'quotes/CHANGE_QUOTE_PRIORITY_ERROR';
export const CHANGE_QUOTE_PRIORITY_SUCCESS =
  'quotes/CHANGE_QUOTE_PRIORITY_SUCCESS';

export const CHANGE_REQUESTED_DATE_REQUEST =
  'quotes/CHANGE_REQUESTED_DATE_REQUEST';
export const CHANGE_REQUESTED_DATE_ERROR = 'quotes/CHANGE_REQUESTED_DATE_ERROR';

export const CONTACT_CONFLICT_OPEN_MODAL = 'quotes/CONTACT_CONFLICT_OPEN_MODAL';
export const CONTACT_CONFLICT_CLOSE_MODAL =
  'quotes/CONTACT_CONFLICT_CLOSE_MODAL';
export const CONTACT_CONFLICT_RESOLVE = 'quotes/CONTACT_CONFLICT_RESOLVE';
export const CONTACT_CONFLICT_SUCCESS = 'quotes/CONTACT_CONFLICT_SUCCESS';
export const CONTACT_CONFLICT_ERROR = 'quotes/CONTACT_CONFLICT_ERROR';

export const REORDER_QUOTE_ITEMS_FLOW = 'quotes/REORDER_QUOTE_ITEMS_FLOW';
export const REORDER_QUOTE_ITEMS_REQUEST = 'quotes/REORDER_QUOTE_ITEMS_REQUEST';
export const REORDER_QUOTE_ITEMS_SUCCESS = 'quotes/REORDER_QUOTE_ITEMS_SUCCESS';

export const DOWNLOAD_NEST_PDF_REQUEST =
  'quotes/nesting/DOWNLOAD_NEST_PDF_REQUEST';
export const DOWNLOAD_NEST_PDF_SUCCESS =
  'quotes/nesting/DOWNLOAD_NEST_PDF_SUCCESS';
export const DOWNLOAD_NEST_PDF_ERROR = 'quotes/nesting/DOWNLOAD_NEST_PDF_ERROR';

export const PART_REINTERROGATION_ERROR = 'quotes/PART_REINTERROGATION_ERROR';
export const PART_REINTERROGATION_REQUEST =
  'quotes/PART_REINTERROGATION_REQUEST';
export const PART_REINTERROGATION_SUCCESS =
  'quotes/PART_REINTERROGATION_SUCCESS';

export const BAQ_PAGE_INIT_REQUEST = 'quotes/BAQ_PAGE_INIT_REQUEST';
export const BAQ_PAGE_INIT_SUCCESS = 'quotes/BAQ_PAGE_INIT_SUCCESS';
export const BAQ_PAGE_INIT_ERROR = 'quotes/BAQ_PAGE_INIT_ERROR';

export const QUOTE_RFQ_NUMBER_UPDATE_REQUEST =
  'quotes/QUOTE_RFQ_NUMBER_UPDATE_REQUEST';
export const QUOTE_RFQ_NUMBER_UPDATE_SUCCESS =
  'quotes/QUOTE_RFQ_NUMBER_UPDATE_SUCCESS';
export const QUOTE_RFQ_NUMBER_UPDATE_ERROR =
  'quotes/QUOTE_RFQ_NUMBER_UPDATE_ERROR';

export const RECEIVE_OPEN_TASK_COUNT = 'quotes/RECEIVE_OPEN_TASK_COUNT';

export const REFETCH_QUOTE_ITEM_HEADERS_REQUEST =
  'quotes/REFETCH_QUOTE_ITEM_HEADERS_REQUEST';
export const REFETCH_QUOTE_ITEM_HEADERS_SUCCESS =
  'quotes/REFETCH_QUOTE_ITEM_HEADERS_SUCCESS';
export const REFETCH_QUOTE_ITEM_HEADERS_ERROR =
  'quotes/REFETCH_QUOTE_ITEM_HEADERS_ERROR';
